import { Box, Flex, Input, Radio, Text } from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { IAllCourse } from '../../../../models/allcourse.model';
import registrationService from '../../../../services/registration.service';

const SponsorPaymentAmount = ({ nextPage, ...rest }: { nextPage: any; }) => {

    const navigate = useNavigate()
    const { course_id } = useParams();
    const [course, setCourse] = useState<IAllCourse>()
    const [loading, setLoading] = useState(true);




    useEffect(() => {
        
        registrationService.getEachCourse(course_id)
            .then((response) => {
                setCourse(response)
                setLoading(false)
                
            })
            .catch((err) => err)

    }, [])

    return (
        <Box px={6} mb='50px' >
            <Flex justifyContent='center' mt='60px' mb='35px'>
                <Text mx='auto' color='#616161' fontSize='20px' fontWeight='700'>Sponsors Details</Text>
            </Flex>
            <Box py='8px' borderRadius='8px' boxShadow='base' mb='20px'>
                <Flex justifyContent='space-between' pt='25px' pb='15px' px='30' borderBottom='1px solid' borderColor='lightgray'>
                    <Text>
                        Sponsor
                    </Text>
                    <Text>Globacom</Text>
                </Flex>
                <Flex justifyContent='space-between' pt='25px' pb='15px' px='30' >
                    <Text>
                        SponsorId
                    </Text>
                    <Text>     SPN-5749393792</Text>
                </Flex>

            </Box>
            <Box py='8px' borderRadius='8px' boxShadow='base'>
                <Flex justifyContent='space-between' pt='25px' pb='15px' px='30' >
                    <Radio colorScheme='red' value='1'>Remita</Radio>
                    <Input  ml='20px' width='100%' type='number'
                        color="#959595" bg="white" mr='20px' height='45px'
                        placeholder="Enter Amount"
                        fontSize='14px'
                        variant='flushed'
                        size="sm" />
                </Flex>
            </Box>


        </Box>
    );
}

export default SponsorPaymentAmount;